import { apiClient } from '@/lib/api-client';
import type { GuestSignupResponse, UserMeResponse } from '../types/auth.types';

/**
 * Auth API service
 */
export const authApi = {
  /**
   * Sign up as a guest user
   */
  async signUpGuest(): Promise<GuestSignupResponse> {
    return apiClient.post<GuestSignupResponse>('/api/v1/auth/guest');
  },

  /**
   * Get current user info
   */
  async getUserMe(): Promise<UserMeResponse> {
    return apiClient.get<UserMeResponse>('/api/v1/users/me');
  },
};
